"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hipConfig = {
    showInstruction: true,
    showMenu: true,
    instructionsInside: true,
    holder: 'captchaImage',
    scriptHolder: 'captchaScript',
    type: 'visual',
    market: 'en-us',
    cssSet: {
        cssCdHIPMenu: 'menu',
        cssCdHIPInput: 'solution',
        cssCdHIPLink: 'link',
        cssCdHIPError: 'error',
        cssCdHIPErrorImg: 'imageError',
    },
    // tslint:disable-next-line:no-empty
    postLoad: () => { },
};
